import React, { useState, useEffect } from "react";
import Autosuggest from "react-autosuggest";
import classNames from "classnames";
import { FaSearch, FaTimes } from "react-icons/fa";
import { useDebounce } from "../../Hooks/";
import "./styles/DynamicSearchInput.scss";
import FieldDisabled from "../FieldDisabled";

const DynamicSearchInput = (props) => {
  const { formValues, formApi, schemaProps, addItem, descriptors, disabled } =
    props;
  const { disableWhenField } = schemaProps;

  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  // const [isLoading, setIsLoading] = useState(false);
  const [hideClearButton, setHideClearButton] = useState(false);

  const debouncedValue = useDebounce(value, 500);

  let inputClasses = classNames("usa-input", "dynamic-search-input", {
    // "usa-input-error": display_errors_on_page && !(_value.length > 0),
    // "usa-input-disabled": readOnly,
    // "dynamic-search-input--success": valueSelected === true
  });
  useEffect(() => {
    const { machine_name, field_to_modify } = schemaProps;
    if (!addItem) {
      const display_value = createDisplayValue(
        formValues,
        formApi,
        machine_name,
        field_to_modify
      );

      if (display_value !== undefined) {
        setValue(display_value);
      }
    }

    if (schemaProps.hideClearButton) {
      setHideClearButton(true);
    }
  }, [formValues, formApi, schemaProps, addItem]);

  useEffect(() => {
    const { machine_name, field_to_modify } = schemaProps;
    if (!addItem) {
      const display_value = createDisplayValue(
        formValues,
        formApi,
        machine_name,
        field_to_modify
      );
      if (display_value && value !== display_value) {
        setValue(display_value);
      }
    }
  }, [formValues, formApi, schemaProps, addItem, value]);

  const createDisplayValue = (
    formValues,
    formApi,
    machine_name,
    field_to_get
  ) => {
    let id, description, display_value;

    if (formValues && formValues[machine_name]) {
      id = formValues[machine_name];
      if (formValues[field_to_get]) {
        description = formValues[field_to_get];
      }
      if (description) {
        display_value = `${id} —— ${description}`;
      } else {
        const index_of_comma = id.indexOf(",");
        description = id.slice(index_of_comma + 1, id.length);
        id = id.slice(0, index_of_comma);
        display_value = `${id} —— ${description}`;
        formApi.change(machine_name, id);
        formApi.change(field_to_get, description);
      }
    }

    return display_value;
  };

  useEffect(() => {
    const results = props.searchAdapter(value);
    results.then((data) => {
      if (data.value) {
        setSuggestions(data.value);
        // setIsLoading(false);
      }
    });
  }, [debouncedValue]);

  const onChange = (event, { newValue }) => {
    if (event.key && event.key !== "Enter") {
      return;
    }
    const { input, formApi, schemaProps, addItem } = props;
    const { field_to_modify } = schemaProps;

    let values = newValue.split("——");

    let id, description;

    if (values) {
      if (values[0] && values[0] !== undefined) {
        id = values[0].trim();
      }
      if (values[1] && values[1] !== undefined) {
        description = values[1].trim();
      }
      if (id && description) {
        if (addItem) {
          addItem({ id, description });
        } else {
          input.onChange(id);
          formApi.change(field_to_modify, description);
        }
      }
    }

    setValue(newValue);
  };

  const onBlur = (e) => {
    let { formApi, input } = props;
    formApi.mutators.setFieldTouched(input.name, true);
  };

  const clearInputValue = () => {
    let {
      formApi,
      input: { name },
      addItem,
    } = props;
    setValue("");
    setSuggestions([]);
    if (!addItem) {
      formApi.change(name, undefined);
    }
  };

  const onFocus = (e) => {
    clearInputValue();
  };

  const onSuggestionSelected = (e, ...rest) => {
    const { addItem } = props;
    if (addItem) {
      clearInputValue();
    }
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    // loadSuggestions(value);
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const getSuggestionValue = (suggestion) => {
    const { _id, _title } = descriptors;
    if (suggestion) {
      return `${suggestion[_id]} —— ${suggestion[_title]}`;
    }
    return ``;
  };

  const renderInputComponent = (inputProps) => (
    <div className="input-container">
      <span className="search-input-icon--beginning">
        <FaSearch color={"#0071BC"} />
      </span>
      {!hideClearButton || inputProps.disabled ? (
        ""
      ) : (
        <span
          className="search-input-icon--end"
          onClick={(e) => {
            clearInputValue();
          }}
        >
          <FaTimes color={"#0071BC"} />
        </span>
      )}

      <input
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
        {...inputProps}
      />
    </div>
  );

  const renderSuggestion = (suggestion) => {
    const { _id, _title } = descriptors;
    if (suggestion !== undefined) {
      return (
        <span className="dynamic-wheel-content">{`${suggestion[_id]} —— ${suggestion[_title]}`}</span>
      );
    }
    return null;
  };

  const theme = {
    container: "react-autosuggest__container",
    containerOpen: "react-autosuggest__container--open",
    input: inputClasses,
    inputOpen: "react-autosuggest__input--open",
    inputFocused: "react-autosuggest__input--focused",
    suggestionsContainer: "react-autosuggest__suggestions-container",
    suggestionsContainerOpen: "react-autosuggest__suggestions-container--open",
    suggestionsList: "react-autosuggest__suggestions-list",
    suggestion: "react-autosuggest__suggestion",
    suggestionFirst: "react-autosuggest__suggestion--first",
    suggestionHighlighted: "react-autosuggest__suggestion--highlighted",
    sectionContainer: "react-autosuggest__section-container",
    sectionContainerFirst: "react-autosuggest__section-container--first",
    sectionTitle: "react-autosuggest__section-title",
  };

  let isDisabled = false;
  if (disableWhenField !== undefined) {
    if (typeof disableWhenField === "string") {
      isDisabled = FieldDisabled(disabled, disableWhenField, formApi);
    } else if (typeof disableWhenField === "function") {
      isDisabled = disableWhenField(formApi.getState().values);
    } else {
      isDisabled = FieldDisabled(
        disabled,
        disableWhenField,
        formApi,
        undefined,
        disableWhenField.is
      );
    }
  } else {
    isDisabled = disabled;
  }

  const inputProps = {
    value,
    onChange,
    onBlur,
    onFocus,
    placeholder: "Type search term here",
    disabled: isDisabled,
  };

  return (
    <Autosuggest
      theme={theme}
      suggestions={suggestions}
      renderInputComponent={renderInputComponent}
      inputProps={inputProps}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      focusInputOnSuggestionClick={false}
      onSuggestionSelected={onSuggestionSelected}
    />
  );
};

export default DynamicSearchInput;
